import { Link } from "react-router-dom";
import { Phone, Mail, Facebook, Linkedin, Instagram } from "lucide-react";
import NewsletterSignup from "./NewsletterSignup";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-primary text-primary-foreground">
      <div className="container mx-auto px-4 py-12">
        <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-8">
          {/* Logo and Company Info */}
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center justify-center space-x-2 mb-4">
              <img 
                src="/processing-bros-logo-light.png" 
                alt="Processing Bros - Your Success, Our Process" 
                className="w-[100px] sm:w-[120px] h-auto"
                width="120"
                height="28"
                loading="lazy"
                decoding="async"
              />
            </Link>
            <p className="text-primary-foreground/80 text-sm mb-4">
              Professional payment solutions for South Florida businesses since 2018.
            </p>
            <a 
              href="https://merchantech.com/app/bradley-brown/"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block mb-4 px-4 py-2 bg-accent text-accent-foreground rounded-lg text-sm font-medium hover:bg-accent/90 transition-colors"
            >
              Apply Now →
            </a>
            <div className="flex gap-3">
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="p-2 rounded-full bg-primary-foreground/10 hover:bg-primary-foreground/20 transition-colors" aria-label="Facebook">
                <Facebook className="h-4 w-4" />
              </a>
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="p-2 rounded-full bg-primary-foreground/10 hover:bg-primary-foreground/20 transition-colors" aria-label="LinkedIn">
                <Linkedin className="h-4 w-4" />
              </a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="p-2 rounded-full bg-primary-foreground/10 hover:bg-primary-foreground/20 transition-colors" aria-label="Instagram">
                <Instagram className="h-4 w-4" />
              </a>
            </div>
          </div>

          {/* Services */}
          <div>
            <h3 className="font-semibold mb-4">Services</h3>
            <ul className="space-y-2 text-sm text-primary-foreground/80">
              <li><Link to="/services/merchant-processing" className="hover:text-primary-foreground transition-colors">Merchant Processing</Link></li>
              <li><Link to="/services/pos-systems" className="hover:text-primary-foreground transition-colors">POS Systems</Link></li>
              <li><Link to="/services/payment-gateways" className="hover:text-primary-foreground transition-colors">Payment Gateways</Link></li>
              <li><Link to="/services/cash-discount-program" className="hover:text-primary-foreground transition-colors">Cash Discount</Link></li>
              <li><Link to="/services/high-risk-processing" className="hover:text-primary-foreground transition-colors">High-Risk Processing</Link></li>
              <li><Link to="/free-rate-analysis" className="hover:text-primary-foreground transition-colors">Free Rate Analysis</Link></li>
            </ul>
          </div>

          {/* Industries */}
          <div>
            <h3 className="font-semibold mb-4">Industries</h3>
            <ul className="space-y-2 text-sm text-primary-foreground/80">
              <li><Link to="/industries/restaurant-processing" className="hover:text-primary-foreground transition-colors">Restaurants</Link></li>
              <li><Link to="/industries/retail-processing" className="hover:text-primary-foreground transition-colors">Retail Stores</Link></li>
              <li><Link to="/industries/smoke-shop-processing" className="hover:text-primary-foreground transition-colors">Smoke Shops</Link></li>
              <li><Link to="/industries/bar-nightclub-processing" className="hover:text-primary-foreground transition-colors">Bars & Nightclubs</Link></li>
              <li><Link to="/industries/convenience-store-processing" className="hover:text-primary-foreground transition-colors">Convenience Stores</Link></li>
            </ul>
          </div>

          {/* Locations */}
          <div>
            <h3 className="font-semibold mb-4">Locations</h3>
            <ul className="space-y-2 text-sm text-primary-foreground/80">
              <li><Link to="/locations/fort-lauderdale-fl/merchant-processing" className="hover:text-primary-foreground transition-colors">Fort Lauderdale</Link></li>
              <li><Link to="/locations/miami-dade-fl/merchant-processing" className="hover:text-primary-foreground transition-colors">Miami-Dade</Link></li>
              <li><Link to="/locations/broward-county-fl/merchant-processing" className="hover:text-primary-foreground transition-colors">Broward County</Link></li>
              <li><Link to="/locations/palm-beach-fl/merchant-processing" className="hover:text-primary-foreground transition-colors">Palm Beach</Link></li>
              <li><Link to="/locations/boca-raton-fl/merchant-processing" className="hover:text-primary-foreground transition-colors">Boca Raton</Link></li>
            </ul>
          </div>

          {/* Contact & Newsletter */}
          <div>
            <h3 className="font-semibold mb-4">Contact</h3>
            <div className="space-y-3 text-sm text-primary-foreground/80 mb-4">
              <div className="flex items-center">
                <Phone className="h-4 w-4 mr-2" />
                <a href="tel:9543992230" className="hover:text-primary-foreground transition-colors">
                  (954) 399-2230
                </a>
              </div>
              <div className="flex items-center">
                <Mail className="h-4 w-4 mr-2" />
                <a href="mailto:support@processingbros.com" className="hover:text-primary-foreground transition-colors">
                  support@processingbros.com
                </a>
              </div>
            </div>
            <NewsletterSignup />
          </div>
        </div>

        <div className="border-t border-primary-foreground/20 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-primary-foreground/60">
          <p>&copy; {currentYear} Processing Bros. All rights reserved.</p>
          <div className="flex gap-4">
            <Link to="/about" className="hover:text-primary-foreground transition-colors">About</Link>
            <Link to="/blog" className="hover:text-primary-foreground transition-colors">Blog</Link>
            <Link to="/cancellation-return-policy" className="hover:text-primary-foreground transition-colors">Terms</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
